/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_TitleInputs */

const vi_tea_lot_title = /** @type {(inputs: Tea_Lot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô chè`)
};

/**

* @param {Tea_Lot_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_title = /** @type {((inputs?: Tea_Lot_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_title(inputs)
});